import React from "react";
import { Row, Col, Button, Image, Badge } from "react-bootstrap";
import dad from "../../assets/images/index/dad.jpg";
import mum from "../../assets/images/index/mum.jpg";
import daughter from "../../assets/images/index/daughter.jpg";
import logoIcon from "../../assets/images/logo-icon.svg";

const SupportUserSection = () => {
  return (
    <section className="pb-11 pb-md-12 pb-xl-13 pb-xxxl-14 position-relative overflow-hidden">
      <Row className="justify-content-center mb-10 mb-md-11 mb-xl-12">
        <Col xl="20" xxxl="17">
          <h2 className="text-center mb-5 mb-md-6">
            Support when it matters most
          </h2>
          <p className="lead text-dark text-center mb-0">
            Give trusted family or friends quiet access to help keep life organised
          </p>
        </Col>
      </Row>
      <div className="usp-section-bg-container d-flex justify-content-center align-items-center position-absolute start-50 translate-middle w-100 h-100 mt-14">
        <div className="circle-1 border rounded-circle position-absolute"></div>
        <div className="circle-2 border rounded-circle position-absolute"></div>
        <div className="circle-3 border rounded-circle position-absolute"></div>
      </div>
      <Row className="usp-section justify-content-center position-relative gx-5 gx-md-7 gx-xl-9 gx-xxxl-10">
        <Col xs="auto" className="d-flex flex-column align-items-center">
          <div className="img-avatar mb-4">
            <Image src={dad} className="img-object-fit-cover" alt="" />
          </div>
          <div className="fw-bold text-dark">Dad</div>
          <div>Main user</div>
        </Col>
        <Col
          xs="auto"
          className="d-flex justify-content-center align-items-end"
        >
          <Image src={logoIcon} className="d-md-none mb-7" height="33" alt="" />
          <Image
            src={logoIcon}
            className="d-none d-md-block d-xxxl-none mb-7"
            height="40"
            alt=""
          />
          <Image
            src={logoIcon}
            className="d-none d-xxxl-block mb-7"
            height="48"
            alt=""
          />
        </Col>
        <Col xs="auto" className="d-flex flex-column align-items-center">
          <div className="img-avatar mb-4">
            <Image src={mum} className="img-object-fit-cover" alt="" />
          </div>
          <div className="fw-bold text-dark">Mum</div>
          <div>Main user</div>
        </Col>
        <Col
          xs="auto"
          className="d-flex flex-column align-items-center position-absolute support-user"
        >
          <div className="img-avatar mb-4">
            <Image src={daughter} className="img-object-fit-cover" alt="" />
          </div>
          <div className="fw-bold text-dark">Daughter</div>
          <div>Support user</div>
        </Col>
        <Col className="mt-13 position-absolute w-100 d-flex justify-content-center" style={{ left: 0, right: 0 }}>
          <ul className="list-unstyled orbit-container">
            <li className="badge-orbit badge-orbit-bills">
              <Badge bg="primary-light d-flex justify-content-center rounded-circle p-3 mb-2">
                <i className="fa-solid fa-receipt fa-xl lh-1 text-info"></i>
              </Badge>
              <div className="small-xs">Bills</div>
            </li>
            <li className="badge-orbit badge-orbit-insurance">
              <Badge bg="primary-light d-flex justify-content-center rounded-circle p-3 mb-2">
                <i className="fa-solid fa-umbrella fa-xl lh-1 text-info"></i>
              </Badge>
              <div className="small-xs">Insurance</div>
            </li>
            <li className="badge-orbit badge-orbit-appointments">
              <Badge bg="primary-light d-flex justify-content-center rounded-circle p-3 mb-2">
                <i className="fa-solid fa-stopwatch fa-xl lh-1 text-info"></i>
              </Badge>
              <div className="small-xs">Appointments</div>
            </li>
            <li className="badge-orbit badge-orbit-giftcards">
              <Badge bg="primary-light d-flex justify-content-center rounded-circle p-3 mb-2">
                <i className="fa-solid fa-gift fa-xl lh-1 text-info"></i>
              </Badge>
              <div className="small-xs">Gift cards</div>
            </li>
            <li className="badge-orbit badge-orbit-warranties">
              <Badge bg="primary-light d-flex justify-content-center rounded-circle p-3 mb-2">
                <i className="fa-solid fa-shield fa-xl lh-1 text-info"></i>
              </Badge>
              <div className="small-xs">Warranties</div>
            </li>
            <li className="badge-orbit badge-orbit-reminders">
              <Badge bg="primary-light d-flex justify-content-center rounded-circle p-3 mb-2">
                <i className="fa-solid fa-bell fa-xl lh-1 text-info"></i>
              </Badge>
              <div className="small-xs">Reminders</div>
            </li>

            {/* Tiny glowing decorative dots (floating nodes) */}
            {[
              { orbit: "var(--dot-radius-1)", duration: "22s", delay: "-4s" },
              { orbit: "var(--dot-radius-1)", duration: "26s", delay: "-16s" },
              { orbit: "var(--dot-radius-2)", duration: "30s", delay: "-8s" },
              { orbit: "var(--dot-radius-2)", duration: "33s", delay: "-22s" },
              { orbit: "var(--dot-radius-3)", duration: "37s", delay: "-5s" },
              { orbit: "var(--dot-radius-3)", duration: "41s", delay: "-18s" },
              { orbit: "var(--dot-radius-3)", duration: "45s", delay: "-29s" },
            ].map((dot, index) => (
              <li
                key={`dot-${index}`}
                className="badge-orbit d-flex align-items-center justify-content-center"
                style={{
                  "--orbit-radius": dot.orbit,
                  animation: `orbit-with-fade ${dot.duration} linear infinite ${dot.delay}`,
                }}
              >
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    backgroundColor: "#36f1cc",
                    boxShadow: "0 0 12px rgba(54, 241, 204, 0.9)",
                    opacity: 0.7,
                  }}
                />
              </li>
            ))}
          </ul>
        </Col>
      </Row>
      <div className="text-center mt-11">
        <Button href="/plans" size="lg">
          Start Free Trial
        </Button>
      </div>
    </section>
  );
};

export default SupportUserSection;
